import { render, staticRenderFns } from "./AddVisitPerson.vue?vue&type=template&id=a5617c4c&scoped=true&"
import script from "./AddVisitPerson.vue?vue&type=script&lang=js&"
export * from "./AddVisitPerson.vue?vue&type=script&lang=js&"
import style0 from "./AddVisitPerson.vue?vue&type=style&index=0&id=a5617c4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5617c4c",
  null
  
)

export default component.exports